import FreeFingerprint, { IFingerprintService, PaidFingerprint } from './FingerPrintService';
import JourneyParameters from '@/models/interfaces/JourneyParameters';

export default class FingerprintHandler {
  private fingerprintQuarantineRange: number = 0;
  private enableCollectingFingerprint: boolean = false;
  private fingerprintApiKey: string = '';
  private isPaidFingerprint: boolean = false;

  constructor(surveyAnswer?: JourneyParameters) {
    const { fingerprintQuarantineRange, enableColletingFingerprint, fingerprintApiKey } = surveyAnswer || {};

    this.fingerprintQuarantineRange = Number(fingerprintQuarantineRange);
    this.enableCollectingFingerprint = enableColletingFingerprint;
    this.fingerprintApiKey = fingerprintApiKey;
    this.isPaidFingerprint = !!fingerprintApiKey;
  }

  public async getFingerprint(): Promise<string> {
    if (this.fingerprintQuarantineRange > 0 || this.enableCollectingFingerprint) {
      return await this.selectFingerprint();
    } else {
      return null;
    }
  }

  private async selectFingerprint(): Promise<string> {
    const fingerprintService: IFingerprintService = this.isPaidFingerprint
      ? new PaidFingerprint()
      : new FreeFingerprint();

    const fingerprintVisitorId: string = await fingerprintService.getVisitorIdentifier(this.fingerprintApiKey);
    return fingerprintVisitorId;
  }
}
